import moment from "moment";
import React, { Fragment, useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import Select from 'react-select';
import { Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, Row, ModalHeader } from "reactstrap";
import { Colxx } from "../../../../../../../components/common/CustomBootstrap";
import CustomSelectInput from "../../../../../../../components/common/CustomSelectInput";
import { gAPI_Promo_Codes_By_Id, putAPI_Update_Promo_Codes } from "../../../../../../../constants/APIs";
import { AxiosAPI, getGroupID } from "../../../../../../../helpers/AxiosAPI";
function PromoCodeForm({ propertyId, isVisible, toggle, formLabel, id, vouchers, handleSubmit }) {
    const [promoCodes, setPromoCodes] = useState([]);
    const [selectedVouchers, setSelectedVocuhers] = useState([]);
    const [promoCodeData, setPromoCodeData] = useState({
        startDate: moment().add(2, 'days').format('YYYY-MM-DD'),
        endDate: moment().add(1, 'month').format('YYYY-MM-DD'),
        groupId: getGroupID(),
        propertyId: propertyId,
        promoType: 'Percentage',
        promoStatus: 'Draft',
        voucherType: 'AllVoucher',
        promoCodeValue: 0,
        vouchers: [],
        creater: 'Admin',
        promoCode: '',
        creator: 'Admin'
    })
    const handleChange = (e) => {
        setPromoCodeData({
            ...promoCodeData,
            [e.target.name]: e.target.value,
        });
    }

    const handleChangeTags = (seelctedVouchers) => {
        setSelectedVocuhers(seelctedVouchers);
        const tagsArr = seelctedVouchers.map((elem) => elem.value);
        setPromoCodeData({
            ...promoCodeData,
            vouchers: tagsArr,
        });
    };

    const handleSave = () => {
        if (id !== undefined)
            handleSubmit(promoCodeData);
        else
            handleSubmit(promoCodeData, id);
        toggle();
    }

    useEffect(() => {
        if (id !== undefined) {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Promo_Codes_By_Id}/${id}`,
            })
                .then((res) => {                    
                    setPromoCodeData(res.data);                    
                    if(res.data.vouchers.length > 0 && res.data.voucherType ==='SelectedVoucher'){
                        let lst=[];
                        res.data.vouchers.map(m=> {
                            if(vouchers.filter(f=>f.value === m).length > 0){
                                let obj =vouchers.filter(f=>f.value === m)[0];
                                lst.push({  label: obj.label,
                                    value: obj.id,
                                    key: obj.id,})
                            }
                        });                        
                    setSelectedVocuhers(lst);
                    }
                });
        }
    }, [propertyId]);
    
    return (
        <Fragment>
            <Modal
                isOpen={isVisible}
                toggle={toggle}
                size="lg"
                style={{ maxWidth: '1000px', right: `${id !== undefined ? "0rem" : "0rem"}` }}
            >
                <ModalHeader toggle={toggle}>
                    <div class="row mt-1 text-left" style={{ width: '900px' }}>
                        <div className='col-md-6 mt-2'>
                            {formLabel}
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Colxx xxs="12">
                        <Row>
                            <Colxx sm={6} className="mb-3">
                                <Label>Promo Code<span style={{ color: 'red' }}> *</span></Label>
                                <Input
                                    value={promoCodeData.promoCode}
                                    onChange={handleChange}
                                    name="promoCode"
                                />
                            </Colxx>

                            <Colxx sm={3} className="mb-3">
                                <Label>Start Date<span style={{ color: 'red' }}> *</span></Label>
                                <Input
                                    required
                                    type="date"
                                    name="startDate"
                                    value={moment(promoCodeData.startDate).format('YYYY-MM-DD')}
                                    onChange={handleChange}
                                />
                            </Colxx>
                            <Colxx sm={3} className="mb-3">
                                <Label>End Date<span style={{ color: 'red' }}> *</span></Label>
                                <Input
                                    required
                                    type="date"
                                    name="endDate"
                                    value={moment(promoCodeData.endDate).format('YYYY-MM-DD')}
                                    onChange={handleChange}
                                />
                            </Colxx>

                            <Colxx sm={3} className="mb-3">
                                <Label>Status<span style={{ color: 'red' }}> *</span></Label>
                                <Input
                                    type="select"
                                    value={promoCodeData.promoStatus}
                                    name="promoStatus"
                                    onChange={handleChange}
                                >
                                    <option value="Draft">Draft</option>
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                    <option value="Archived">Archived</option>
                                </Input>
                            </Colxx>


                            <Colxx sm={3} className="mb-3">
                                <Label>Voucher Type<span style={{ color: 'red' }}> *</span></Label>
                                <Input
                                    type="select"
                                    value={promoCodeData.voucherType}
                                    name="voucherType"
                                    onChange={handleChange}
                                >
                                    <option value="AllVoucher">All</option>
                                    <option value="SelectedVoucher">Selected</option>
                                </Input>
                            </Colxx>

                            {promoCodeData.voucherType === 'SelectedVoucher' &&
                                <Colxx sm={6}>
                                    <FormGroup>
                                        <Label for="bookingUrl">Vouchers</Label>
                                        <Select
                                            components={{ Input: CustomSelectInput }}
                                            className="react-select"
                                            classNamePrefix="react-select"
                                            isMulti={true}
                                            name="form-field-name"
                                            value={selectedVouchers}
                                            onChange={handleChangeTags}
                                            options={vouchers}
                                        />
                                    </FormGroup>
                                </Colxx>}

                            <Colxx sm={3} className="mb-3">
                                <Label>Promo Type<span style={{ color: 'red' }}> *</span></Label>
                                <Input
                                    type="select"
                                    value={promoCodeData.promoType}
                                    name="promoType"
                                    onChange={handleChange}
                                >
                                    <option value="Percentage">Percentage</option>
                                    <option value="Amount">Amount</option>
                                </Input>
                            </Colxx>

                            <Colxx sm={3} className="mb-3">
                                <Label>Promo Code Value<span style={{ color: 'red' }}> *</span></Label>
                                <Input
                                    type="number"
                                    value={promoCodeData.promoCodeValue}
                                    onChange={handleChange}
                                    name="promoCodeValue"
                                />
                            </Colxx>

                        </Row>
                    </Colxx>

                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={() => handleSave()}>
                        Save
                    </Button>
                    <Button color="secondary" onClick={() => toggle()}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );

}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale, currency } = settings;
    return {
        propertyId,
        locale,
        currency
    };
};

export default injectIntl(connect(mapStateToProps, {})(PromoCodeForm));